import { initKpiSlice, KpiCommands } from '@skynet/data-shared-kpi';
import { resetStore } from 'src/store/actions';

export enum LoanKpiCommands {
  KPI = 'LoanKPI',
}

const { reducer, actions } = initKpiSlice({
  prefix: 'loans',
  sliceName: 'loansKpi',
  commands: { ...KpiCommands, ...LoanKpiCommands },
  resetAction: resetStore,
});

export const loanKpiActions = actions;
export default reducer;
